import { useQuery } from '@tanstack/react-query';
import { dashboardMainService } from 'v2/services/dashboardMain';

export const useBestsellers = (days: '7' | '30' | 'all' = '7') => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['dashboard', 'bestsellers', days],
    queryFn: () => dashboardMainService.bestsellers(days)
  });

  return { bestsellers: data?.data ?? [], isLoading, error, refetch };
};
